/* =============================================================================
 * art.js — the photography manifest.
 *
 * Every photographic slot on the site is declared here once: its file path,
 * its aspect ratio, its alt text. Components read from this list, so swapping
 * an image is a one-line change and never a hunt through JSX.
 *
 * The three photographs were supplied by the founder (2026-08-30) and are
 * synthetic imagery: no real, identifiable minor is depicted, so there is no
 * model release to collect or expire. If any slot is ever replaced with a real
 * photograph of recognisable kids, a guardian's release becomes a standing
 * obligation — prefer generated or properly licensed stock instead.
 * ===========================================================================*/

export const PHOTOS = {
  hero: {
    ready: true,
    src: '/img/hero-huddle.jpg',
    width: 1800,
    height: 1350,
    ratio: '4 / 3',
    alt:
      'A coach kneeling in a timeout huddle with a clipboard, the whole team ' +
      'leaning in around him.',
    slot: 'HERO',
    brief: 'The huddle. Where the plan gets made.',
  },

  film: {
    ready: true,
    src: '/img/crowd.jpg',
    width: 1600,
    height: 1067,
    ratio: '3 / 2',
    alt:
      'A packed student section in a gym, dozens of phones up recording the ' +
      'game.',
    slot: 'FILM',
    brief: 'The stands already film every game. StatMe gives it a home.',
  },

  gym: {
    ready: true,
    src: '/img/hero-dunk.jpg',
    width: 2048,
    height: 1365,
    ratio: '3 / 2',
    alt:
      'A high school player rising for a dunk in a packed gym, the scoreboard ' +
      'and crowd behind him.',
    slot: 'CLOSING',
    brief: 'Game-winning rise in a packed gym.',
  },
};

/** App screenshots, captured on the iOS Simulator from the real app. */
export const SHOTS = {
  tracker: {
    src: '/img/app/tracker.jpg',
    alt:
      'The live tracker mid-game: the five on-court players as tiles, the ' +
      'running score 18 to 7, and a play-by-play log of makes, assists and ' +
      'blocks.',
  },
  profile: {
    src: '/img/app/profile.jpg',
    alt:
      'A player profile showing per-game averages: 31.9 points, 4 rebounds, ' +
      '6 assists, with shooting percentages below.',
  },
  boxscore: {
    src: '/img/app/boxscore.jpg',
    alt:
      'A finished game, 74 to 52, with the full box score: points, rebounds, ' +
      'assists, steals and blocks for every player.',
  },
  chat: {
    src: '/img/app/chat.jpg',
    alt:
      'The team chat: the coach announces a practice change and players ' +
      'reply, with a reminder that any message can be reported.',
  },
  shotchart: {
    src: '/img/app/shotchart.jpg',
    alt:
      'A post-game shot chart: every shot plotted on the court where it was ' +
      'taken, a green O for each make and a red X for each miss.',
  },
};
